import { render, staticRenderFns } from "./IconProductList.vue?vue&type=template&id=672a1080&"
import script from "./IconProductList.vue?vue&type=script&lang=js&"
export * from "./IconProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports